








































































import { Component, Mixins } from "vue-property-decorator";
import HelperDinamicallyForm from "@/components/DinamicallyForm/HelperDinamicallyForm";
import { cliente } from "@/shared/dtos/cliente";
import Xbtn from "@/components/buttons/x-btn.vue";
import productoModule from "@/store/modules/producto-module";

@Component({
  components: { Xbtn },
})
export default class ScrapingProductos extends Mixins(HelperDinamicallyForm) {
  public async OnCreated() {
    await productoModule.getproductos();
  }
  BotonGuardar = false;
  BotonArchivar = false;
  BotonCancelar = false;
  BotonClonar = false;
  proceso: number = 0;
  proceso_2: number = 0;

  public CreateFields() {
    //Empezamos a crear una pantalla
    //configuracion de la clonacion automatica

    this.AddFormItemDataDefaultSlot(
      undefined,
      "Empezar proceso de extracción de datos: (Imagenes, descripciones, etc)",
      "datos_adicionales",
      9000
    ).CreateInNewROW();
    this.AddFormItemDataDefaultSlot(
      undefined,
      "Empezar proceso de actualización de precios",
      "datos_adicionales_2",
      9000
    ).CreateInNewROW();
  }
  public get Productos_totales() {
    return productoModule.productos.length;
  }
  public Iniciar() {
    //Aqui se inicia el proceso de scraping
    productoModule.extraerAmazon().then(() => {
      const interval = setInterval(() => {
        productoModule.extraerAmazonProceso().then((x: number) => {
          this.proceso = x;
          if (this.proceso === 0) {
            clearInterval(interval);
          }
        });
      }, 1000);
    });
  }
  public IniciarActualizacionPrecios() {
    //Aqui se inicia el proceso de scraping
    productoModule.extraerAmazonPrecios().then(() => {
      const interval = setInterval(() => {
        productoModule.extraerAmazonProcesoPrecios().then((x: number) => {
          this.proceso_2 = x;
          if (this.proceso_2 === 0) {
            clearInterval(interval);
          }
        });
      }, 1000);
    });
  }
  public Insertar(object: cliente) {}

  public Actualizar(object: cliente) {}
}
